var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "company-selector" },
    [
      _c(
        "b-field",
        {
          staticClass: "custom-auto-complete",
          attrs: { label: "Search for a company" },
        },
        [
          _c(
            "b-autocomplete",
            {
              attrs: {
                rounded: "",
                data: _vm.companies,
                placeholder: "Company name...",
                field: "name",
                autofocus: true,
              },
              on: {
                select: function (option) {
                  return _vm.selectCompany(option)
                },
              },
              model: {
                value: _vm.input,
                callback: function ($$v) {
                  _vm.input = $$v
                },
                expression: "input",
              },
            },
            [_c("template", { slot: "empty" }, [_vm._v("No results found")])],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }